(function () {
  function init() {
    document.querySelectorAll('[data-section-type="flip-image"]').forEach(function (section) {
      section.querySelectorAll('.flip-image-item-button[data-flip-button]').forEach(function (btn) {
        var card = btn.closest('.flip-image-card');
        if (!card) return;
        btn.addEventListener('click', function () {
          section.querySelectorAll('.flip-image-card.is-flipped').forEach(function (other) {
            if (other !== card) other.classList.remove('is-flipped');
          });
          card.classList.toggle('is-flipped');
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
